export default __webpack_public_path__ + "static/media/Dice-5.86299255.png";